import { OnboardingWizardRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/onboarding/wizard')({
  component: OnboardingWizardRoute,
});
